const state = {};
const STORE_KEY = 'historyState';
export const setHistoryState = (data) => {
    if (localStorage) {
        try {
            localStorage.setItem(STORE_KEY, JSON.stringify(Object.assign(Object.assign({}, state), data)));
        }
        catch (e) {
        }
    }
};
export const getHistoryState = () => {
    if (localStorage) {
        try {
            const localState = localStorage.getItem(STORE_KEY);
            return localState ? JSON.parse(localState || '{}') : {};
        }
        catch (e) {
            return {};
        }
    }
    return {};
};
